"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSourceTab = exports.SOURCE_TABS = exports.makeTabNamesUnique = exports.makeColumnNamesUnique = exports.getColumnSchemaMap = void 0;
const sheet_db_1 = require("../sheet_db");
const getColumnSchemaMap = (schema) => {
    const idMap = new Map();
    const nameMap = new Map();
    schema.forEach(column => {
        idMap.set(column.column_id, column);
        nameMap.set(column.name, column);
    });
    return { idMap, nameMap };
};
exports.getColumnSchemaMap = getColumnSchemaMap;
const makeColumnNamesUnique = (tabSchema) => {
    // tracks how many times a column name appears
    const nameCountMap = new Map();
    return tabSchema.map(columnSchema => {
        const originalName = columnSchema.name.trim();
        const lowerCaseName = originalName.toLowerCase();
        // first time name appears
        const currentCount = nameCountMap.get(lowerCaseName);
        if (!currentCount) {
            nameCountMap.set(lowerCaseName, 1);
            return columnSchema;
        }
        let count = currentCount + 1;
        // add original name on map to track how many there are
        nameCountMap.set(lowerCaseName, count);
        let newColumnName = `${originalName} - ${count}`;
        while (nameCountMap.has(newColumnName.toLowerCase())) {
            count++;
            newColumnName = `${originalName} - ${count}`; // big query block parenthesis, better to use dash
            nameCountMap.set(lowerCaseName, count);
        }
        nameCountMap.set(newColumnName.toLowerCase(), 1);
        return {
            ...columnSchema,
            name: newColumnName,
        };
    });
};
exports.makeColumnNamesUnique = makeColumnNamesUnique;
const makeTabNamesUnique = (tabs) => {
    const nameCountMap = new Map();
    const sortedTabsById = tabs.sort((tab1, tab2) => tab1.id - tab2.id);
    sortedTabsById.forEach(tab => {
        const tabName = tab.name.trim();
        if (!nameCountMap.has(tabName))
            nameCountMap.set(tabName, 0);
        const currCount = nameCountMap.get(tabName) + 1;
        const name = currCount > 1 ? `${tabName} - ${currCount}` : tabName;
        nameCountMap.set(tabName, currCount);
        nameCountMap.set(name, 1);
        tab.name = name;
    });
};
exports.makeTabNamesUnique = makeTabNamesUnique;
exports.SOURCE_TABS = new Set([
    sheet_db_1.TabType.BIG_QUERY,
    sheet_db_1.TabType.WEBHOOK,
    sheet_db_1.TabType.SOURCE,
    sheet_db_1.TabType.HISTORICAL,
    sheet_db_1.TabType.PULL_V2,
]);
const isSourceTab = (tabType) => tabType && exports.SOURCE_TABS.has(tabType);
exports.isSourceTab = isSourceTab;
